// extracted by mini-css-extract-plugin
export var box = "_p-2";
export var checkboxControl = "_p-0";
export var checkboxRow = "_p-a";
export var checked = "_p-3";
export var descriptionSpacer = "_p-c";
export var disabled = "_p-4";
export var icon = "_p-8";
export var input = "_p-1";
export var labelSpacer = "_p-b";
export var large = "_p-7";
export var medium = "_p-6";
export var small = "_p-5";
export var text = "_p-9";